import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";
import { Howl } from "howler";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    private scaledItemsContainer: Phaser.GameObjects.Container;
    private imageTap: Phaser.GameObjects.Image;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        this.loadHowl();
    }
    
    private composeScene(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "Teko", fontSize: 28, color: "#A6F834" });

        // let bg = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "bg");
        // bg.setOrigin(1, .5);
        // bg.setScale(2, 2 * GameVars.scaleY);

        // bg = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "bg");
        // bg.setOrigin(1, .5);
        // bg.setScale(-2, 2 * GameVars.scaleY);

        this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, 560);
        this.scaledItemsContainer.scaleY = GameVars.scaleY;

        const barWidth = 550;
        const barWHeight = 20;
        const borderWidth = 3;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0x57469A);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        this.scaledItemsContainer.add(preloadBarCapsuleBorder); 

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0x011937 );
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        preloadBarCapsule.x = - barWidth / 2;
        this.scaledItemsContainer.add(preloadBarCapsule); 

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0x42E3FF);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        this.progressBar.x = - barWidth / 2;
        this.progressBar.scaleX = 0;
        this.scaledItemsContainer.add(this.progressBar); 
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.jpg", "assets/texture_atlas_2.json");
        this.load.bitmapFont("teko", "assets/fonts/bitmap/teko.png", "assets/fonts/bitmap/teko.xml");
        this.load.bitmapFont("teko-yellow", "assets/fonts/bitmap/teko-yellow.png", "assets/fonts/bitmap/teko-yellow.xml");

        this.load.image("bg_splash", "assets/splash.jpg")
        this.load.image("logo", "assets/freezenovagames.png")

        this.load.json("audiosprite", "assets/audio/audiosprite.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private loadHowl(): void {

        let soundJson = PreloadScene.currentInstance.cache.json.get("audiosprite");
        soundJson = JSON.parse(JSON.stringify(soundJson).replace("urls", "src"));

        AudioManager.howl = new Howl(soundJson);

        AudioManager.howl.on("load", function() {
            // PreloadScene.currentInstance.showTap();
            PreloadScene.currentInstance.removeLoadBar();
            GameManager.onGameAssetsLoaded();
            PreloadScene.currentInstance.scene.setVisible(false);
        });
    }

    private removeLoadBar(): void {
        
        this.tweens.add({
            targets: this.scaledItemsContainer,
            alpha: 0,
            ease: Phaser.Math.Easing.Linear,
            duration: 500
        });
    }

    private showTap(): void {

        this.scaledItemsContainer.visible = false;

        this.imageTap = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2, 560, "tap");
        this.imageTap.scaleY = GameVars.scaleY;
        this.add.existing(this.imageTap);

        this.tweens.add({
            targets: this.imageTap,
            alpha: .45,
            ease: Phaser.Math.Easing.Linear,
            duration: 1000,
            yoyo: true,
            repeat: -1
        });

        this.input.on("pointerdown", () => {
            this.input.removeAllListeners();
            GameManager.onGameAssetsLoaded();
        }, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }
}
